import React, { useState } from "react";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const FeeStructure = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const FeeStructureData = [
    // accordion 1
    {
      title: "B.Tech Marine Engineering",
      tables: [
        [
          [
            "Sr. No.",
            "Particulars",
            "First Year 2025-26",
            "",
            "Second Year 2025-26",
            "",
            "Third Year 2025-26",
            "",
            "Forth Year 2025-26",
            "",
          ],
          [
            "",
            "",
            "Sem - 1",
            "Sem - 2",
            "Sem - 3",
            "Sem - 4",
            "Sem - 5",
            "Sem - 6",
            "Sem - 7",
            "Sem - 8",
          ],

          [
            1,
            "Academic Fees",
            "₹ 183500",
            "₹ 105000",
            "₹ 141000",
            "₹ 109000",
            "₹ 140000",
            "₹ 110000",
            "₹ 146000",
            "₹ 119000",
          ],
          [
            2,
            "Hostel Fee",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
          ],
          [
            "Total A",
            "",
            "₹ 231000",
            "₹ 152500",
            "₹ 188500",
            "₹ 156500",
            "₹ 187500",
            "₹ 157500",
            "₹ 193500",
            "₹ 166500",
          ],
          [
            1,
            "Mess Charges",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
          ],
          [
            2,
            "Laundry Charges",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
          ],
          [
            "Total B",
            "",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
          ],
          [
            1,
            "1% DGS Fees (On A + B)",
            "₹ 2810",
            "₹ 2025",
            "₹ 2385",
            "₹ 2065",
            "₹ 2375",
            "₹ 2075",
            "₹ 2435",
            "₹ 2165",
          ],
          [
            2,
            "IMEI Fees-*(One Time Only)",
            "₹ 770",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
          ],
          [
            "Total C",
            "",
            "₹ 3580",
            "₹ 2025",
            "₹ 2385",
            "₹ 2065",
            "₹ 2375",
            "₹ 2075",
            "₹ 2435",
            "₹ 2165",
          ],
          [
            "Total Fees (A + B + C) :",
            "",
            "₹ 284580",
            "₹ 204525",
            "₹ 240885",
            "₹ 208565",
            "₹ 239875",
            "₹ 209575",
            "₹ 245935",
            "₹ 218665",
          ],
          [
            "Complete Course Fees ( 4 Years)",
            "",
            "₹ 18,52,605",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
          ],
        ],
      ],

      listItems: [
        "Examination fees as per the subjects in that particular semester as per norms of MIT ADT University. ",
        "INDOS to be paid only once in three years.",
        "All fees are required to be paid at the beginning of each semester. A fee of First Semester is required to be paid on the prescribed date of admission round.",
        "STCW mandatory courses as directed by DGS and value-added courses by the students will attract additional fees.",
        "Fees and other expenses are indicative and are subject to change.",
        "CDC fees (approx. 700/-, at present) must be paid to Shipping Masters office, Govt of India, on-line at the end of 7th semester of the course.",
        "Mess & Laundry charges will change as per Market from second to final year.",
      ],
    },
    // accordion 2
    {
      title:
        "Direct 2nd Year B.Tech. Marine Engineering – Lateral Entry (2025-28)",
      tables: [
        [
          [
            "Sr. No.",
            "Particulars",
            "Second Year 2025-26",
            "",
            "Third Year 2025-26",
            "",
            "Forth Year 2025-26",
            "",
          ],
          [
            "",
            "",
            "Sem - 3",
            "Sem - 4",
            "Sem - 5",
            "Sem - 6",
            "Sem - 7",
            "Sem - 8",
          ],

          [
            1,
            "Academic Fees",
            "₹ 184250",
            "₹ 104250",
            "₹ 141750",
            "₹ 109250",
            "₹ 143750",
            "₹ 117250",
          ],
          [
            2,
            "Hostel Fee",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
          ],
          [
            "Total A",
            "",
            "₹ 231750",
            "₹ 151750",
            "₹ 189250",
            "₹ 156750",
            "₹ 191250",
            "₹ 164750",
          ],
          [
            1,
            "Mess Charges",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
          ],
          [
            2,
            "Laundry Charges",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
          ],
          [
            "Total B",
            "",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
          ],
          [
            1,
            "1% DGS Fees (On A + B)",
            "₹ 2818",
            "₹ 2018",
            "₹ 2393",
            "₹ 2068",
            "₹ 2413",
            "₹ 2148",
          ],
          [2, "IMEI Fees-*(One Time Only)", "₹ 770", "", "", "", "", ""],
          [
            "Total C",
            "",
            "₹ 3588",
            "₹ 2018",
            "₹ 2393",
            "₹ 2068",
            "₹ 2413",
            "₹ 2148",
          ],
          [
            "Total Fees (A + B + C) :",
            "",
            "₹ 285338",
            "₹ 203768",
            "₹ 241643",
            "₹ 208818",
            "₹ 243663",
            "₹ 216898",
          ],
          [
            "Complete Course Fees (4 Years)",
            "",
            "₹ 1400128",
            "",
            "",
            "",
            "",
            "",
          ],
        ],
      ],

      listItems: [
        "Examination fees as per the subjects in that particular semester as per norms of MIT ADT University. ",
        "INDOS to be paid only once in three years.",
        "All fees are required to be paid at the beginning of each semester. A fee of First Semester is required to be paid on the prescribed date of admission round.",
        "STCW mandatory courses as directed by DGS and value-added courses by the students will attract additional fees.",
        "Fees and other expenses are indicative and are subject to change.",
        "CDC fees (approx. 700/-, at present) must be paid to Shipping Masters office, Govt of India, on-line at the end of 7th semester of the course.",
        "Mess & Laundry charges will change as per Market from second to final year.",
      ],
    },
    // accordion 3
    {
      title: "B.Sc. Nautical Science (2025-28)",
      tables: [
        [
          [
            "Sr. No.",
            "Particulars",
            "First Year 2025-26",
            "",
            "Second Year 2025-26",
            "",
            "Third Year 2025-26",
            "",
          ],
          [
            "",
            "",
            "Sem - 1",
            "Sem - 2",
            "Sem - 3",
            "Sem - 4",
            "Sem - 5",
            "Sem - 6",
          ],

          [
            1,
            "Academic Fees",
            "₹ 190000",
            "₹ 120000",
            "₹ 156000",
            "₹ 129000",
            "₹ 150500",
            "₹ 137000",
          ],
          [
            2,
            "Hostel Fee",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
            "₹ 47500",
          ],
          [
            "Total A",
            "",
            "₹ 237500",
            "₹ 167500",
            "₹ 203500",
            "₹ 176500",
            "₹ 198000",
            "₹ 184500",
          ],
          [
            1,
            "Mess Charges",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
            "₹ 42500",
          ],
          [
            2,
            "Laundry Charges",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
            "₹ 7500",
          ],
          [
            "Total B",
            "",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
            "₹ 50000",
          ],
          [
            1,
            "1% DGS Fees (On A + B)",
            "₹ 2875",
            "₹ 2175",
            "₹ 2535",
            "₹ 2265",
            "₹ 2480",
            "₹ 2345",
          ],
          [
            "Total C",
            "",
            "₹ 2875",
            "₹ 2175",
            "₹ 2535",
            "₹ 2265",
            "₹ 2480",
            "₹ 2345",
          ],
          [
            "Total Fees (A + B + C) :",
            "",
            "₹ 290375",
            "₹ 219675",
            "₹ 256035",
            "₹ 228765",
            "₹ 250480",
            "₹ 236845",
          ],
          [
            "Complete Course Fees (4 Years)",
            "",
            "₹ 1482175",
            "",
            "",
            "",
            "",
            "",
          ],
        ],
      ],

      listItems: [
        "Examination fees as per the subjects in that particular semester as per norms of MIT ADT University. ",
        "INDOS to be paid only once in three years.",
        "All fees are required to be paid at the beginning of each semester. Fees of 3rd Semester is required to be paid on the prescribed date of admission round.",
        "STCW mandatory courses as directed by DGS and value-added courses by the students will attract additional fees.",
        "CDC fees (approx. Rs.700/-, at present) must be paid to Shipping Masters office, Govt of India, online at the end of 7th semester of the course.",
        "Fees and estimated expenses are indicative and are subject to change.",
        "Mess & Laundry charges will change as per market from second to final year.",
      ],
    },
    // accordion 4
    {
      title: "Diploma In Nautical Science (DNS) (2025-26)",
      tables: [
        [
          ["Sr. No.", "Particulars", "First Year 2025-26", ""],
          ["", "", "Sem - 1", "Sem - 2"],

          [1, "Academic Fees", "₹ 180750", "₹ 130250"],
          [2, "Hostel Fee", "₹ 47500", "₹ 47500"],
          ["Total A", "", "₹ 228250", "₹ 177750"],
          [1, "Mess Charges", "₹ 42500", "₹ 42500"],
          [2, "Laundry Charges", "₹ 7500", "₹ 7500"],
          ["Total B", "", "₹ 50000", "₹ 50000"],
          [1, "1% DGS Fees (On A + B)", "₹ 2783", "₹ 2278"],
          ["Total C", "", "₹ 2783", "₹ 2278"],
          ["Total Fees (A + B + C) :", "", "₹ 281033", "₹ 230028"],
          ["Complete Course Fees (4 Years)", "", "₹ 511060", "", ""],
        ],
      ],

      listItems: [
        "Examination fees as per the subjects in that particular semester as per norms of MIT ADT University. ",
        "INDOS to be paid only once in three years.",
        "All fees are required to be paid at the beginning of each semester. A fee of First Semester is required to be paid on the prescribed date of admission round.",
        "STCW mandatory courses as directed by DGS and value-added courses opted by the students will attract additional fees.",
        "Fees and other expenses are indicative and are subject to change.",
        " CDC fees (approx. Rs.700/-, at present) must be paid to the Shipping Masters office, Govt of India, online at the end of the course.",
      ],
    },
    // accordion 5
    {
      title: "Electro Technical Officer Course (4 months ) (2025-26)",
      tables: [
        [
          ["Sr. No.", "Particulars", "First Year 2025-26", ""],
          [1, "Academic Fees", "₹ 125500"],
          [2, "Hostel Fee", "₹ 47500"],
          ["Total A", "", "₹ 177750"],
          [1, "Mess Charges", "₹ 42500"],
          [2, "Laundry Charges", "₹ 7500"],
          ["Total B", "", "₹ 50000"],
          ["1% DGS Fees (On A + B)", "", "₹ 2278"],
          ["Total C", "", "₹ 2278"],
          ["Total Fees (A + B + C) :", "", "₹ 230028"],
          ["Complete Course Fees (4 Years)", "", "₹ 511060"],
        ],
      ],

      listItems: [
        "Examination fees as per the subjects in that particular semester as per norms of MIT ADT University. ",
        "INDOS to be paid only once in three years.",
        "All fees are required to be paid at the beginning of each semester. A fee of First Semester is required to be paid on the prescribed date of admission round.",
        "STCW mandatory courses as directed by DGS and value-added courses opted by the students will attract additional fees.",
        "Fees and other expenses are indicative and are subject to change.",
        " CDC fees (approx. Rs.700/-, at present) must be paid to the Shipping Masters office, Govt of India, online at the end of the course.",
      ],
    },
  ];

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div>
      <h1 className="title">Fee Structure For All Courses</h1>
      <hr />
        {Array.isArray(FeeStructureData) &&
          FeeStructureData.map((course, courseIndex) => (
            <div key={courseIndex} className="accordion-item">
              {/* Accordion Header */}
              <Accordion
                title={course?.title || "Untitled"}
                isActive={activeAccordion === courseIndex}
                onClick={() => toggleAccordion(courseIndex)}
              />

              {/* Accordion Content */}
              {activeAccordion === courseIndex && (
                <div className="accordion-content">
                  {Array.isArray(course?.tables) &&
                    course.tables.map((table, tableIndex) => (
                      <div key={tableIndex}>
                        
                        
                        <div className="page-content-table-wrapper">
                        <table className="page-content-table" style={{width:"100%"}}>
                          <thead>
                            {table.slice(0, 2).map((row, rowIndex) => (
                              <tr key={rowIndex}>
                                {row.map((cell, i) => {
                                  // Skip rendering if the cell is part of a merged range (already handled)
                                  if (cell === null) return null;

                                  // ----- HANDLE FIRST HEADER ROW -----
                                  if (rowIndex === 0) {
                                    // Merge repeated year cells horizontally
                                    const isEmpty =
                                      cell === "" ||
                                      cell === null ||
                                      cell === undefined ||
                                      String(cell).trim() === "";

                                    // First two headers ("Sr. No." and "Particulars") span two rows
                                    if (i === 0 || i === 1) {
                                      return (
                                        <th key={i} rowSpan="2">
                                          {cell}
                                        </th>
                                      );
                                    }

                                    // Merge two columns for each year (if next cell is empty)
                                    if (!isEmpty) {
                                      let colSpan = 1;
                                      for (let j = i + 1; j < row.length; j++) {
                                        if (
                                          row[j] === "" ||
                                          row[j] === null ||
                                          row[j] === undefined
                                        ) {
                                          colSpan++;
                                        } else break;
                                      }
                                      return (
                                        <th key={i} colSpan={colSpan}>
                                          {cell}
                                        </th>
                                      );
                                    }

                                    return null;
                                  }

                                  // ----- HANDLE SECOND HEADER ROW -----
                                  else if (rowIndex === 1) {
                                    // Skip first two empty placeholders
                                    if (i < 2) return null;
                                    return <th key={i}>{cell}</th>;
                                  }
                                })}
                              </tr>
                            ))}
                          </thead>

                          {/* BODY */}
                          <tbody>
                            {table.slice(2).map((row, rowIndex) => {
                              // Array to hold processed cells with colSpan info
                              const mergedCells = [];
                              for (let i = 0; i < row.length; i++) {
                                const cell = row[i];
                                const isEmpty =
                                  cell === "" ||
                                  cell === null ||
                                  cell === undefined ||
                                  String(cell).trim() === "";

                                // If current cell is empty → merge it with the previous one
                                if (isEmpty && mergedCells.length > 0) {
                                  mergedCells[
                                    mergedCells.length - 1
                                  ].colSpan += 1;
                                } else {
                                  // Otherwise → create a new entry
                                  mergedCells.push({
                                    text: cell,
                                    colSpan: 1,
                                  });
                                }
                              }

                              // Render processed row
                              return (
                                <tr key={rowIndex}>
                                  {mergedCells.map((cell, i) => (
                                    <td key={i} colSpan={cell.colSpan}>
                                      {cell.text}
                                    </td>
                                  ))}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                       </div>
                    ))}

                  {/* list below table */}
                  {course.listItems && course.listItems.length > 0 && (
                    <ul className="page-content-lists ">
                      <b className="innerpage-subheading">Note:</b>
                      {course.listItems.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))}
      
    </div>
  );
};

export default FeeStructure;
